import React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import NumberUtils from "util/NumberUtils";
import { NavItem } from "components/bootstrap";
import { Spinner } from "components/common";
import { itemStateIndicatorContainerSelector } from "components/common/NavItemStateIndicator";
import { useGlobalThroughput } from "hooks/useMetrics";
const ThroughputNavItem = styled(NavItem)`
  ${itemStateIndicatorContainerSelector} {
    display: inline-block;
  }
`;
const ContentWrap = styled.strong`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 0;
  height: 30px;
`;
const ThroughputData = styled.span(
  ({ $dataIn, theme }) => css`
    font-size: ${theme.fonts.size.small};
    line-height: 1;
    grid-area: ${$dataIn ? "1 / 1 / 2 / 2" : "2 / 1 / 3 / 2"};
    display: grid;
    grid-template-columns: 1fr 1.75em;
    grid-template-rows: 1fr 1px;
    gap: 0 3px;
    color: ${theme.colors.text.primary};

    > span {
      grid-area: 1 / 1 / 2 / 2;
      text-align: right;
      padding-left: 3px;
    }

    > i {
      font-weight: normal;
      grid-area: 1 / 2 / 2 / 3;
    }

    &::after {
      ${$dataIn && css`
        content: ' ';
        min-height: 1px;
        background-color: ${theme.colors.variant.light.default};
        display: block;
        grid-area: 2 / 1 / 3 / 3;
      `}
    }
  `
);
const GlobalThroughput = (props) => {
  const { t } = useTranslation("system");
  const { input, output: outputVal, isLoading } = useGlobalThroughput();
  let output = /* @__PURE__ */ React.createElement(Spinner, { text: "" });
  if (!isLoading) {
    const inputNumeral = NumberUtils.formatNumber(input);
    const outputNumeral = NumberUtils.formatNumber(outputVal);
    output = /* @__PURE__ */ React.createElement(ContentWrap, { "aria-label": t("global_throughput.aria_label", { input: inputNumeral, output: outputNumeral }) }, /* @__PURE__ */ React.createElement(ThroughputData, { $dataIn: true }, /* @__PURE__ */ React.createElement("span", null, inputNumeral), " ", /* @__PURE__ */ React.createElement("i", null, t("global_throughput.in"))), /* @__PURE__ */ React.createElement(ThroughputData, null, /* @__PURE__ */ React.createElement("span", null, outputNumeral), " ", /* @__PURE__ */ React.createElement("i", null, t("global_throughput.out"))));
  }
  return /* @__PURE__ */ React.createElement(ThroughputNavItem, { ...props }, output);
};
export default GlobalThroughput;
